/* eslint-disable max-len */
import { SearchOutlined } from '@ant-design/icons';
import { Card, Col, Input, Row } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import DashboardNotificationType from 'components/atoms/DashboardNotification';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import { extraButton, getAvailablePages, notifikaceMap } from 'components/molecules/DashboardCard';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import emitentApi from 'services/emitent';
import nastavitUcetApi from 'services/nastavitUcet';
import profilyApi, { IPristupy } from 'services/profily';

import { EEmitentJe } from 'enums/isin/emitentJe';
import { EProfilyTyp } from 'enums/profilyTyp';
import routePathEnum from 'enums/routePathEnum';

import getLanguageObject from 'utils/getLanguageObject';

const PrehledUcty: React.FC = () => {
    const { ucty, language } = useContext(Context);
    const [searching, setSearching] = useState<boolean>(false);
    const { setLevel } = useProfily();
    const [profiles, setProfiles] = useState<IPristupy[]>([]);
    const [emitentProfiles, setEmitentProfiles] = useState<IPristupy[]>();
    const [searchValue, setSearchValue] = useState<string>('');
    const firstRenderRef = useRef(true);
    const { navigateWorkaround } = useNavigateWorkaround();

    useEffect(() => {
        if (profiles || ucty) {
            setEmitentProfiles(
                ((profiles.length && profiles) || (ucty?.length && ucty) || []).filter(
                    e => e.typ === EProfilyTyp.EMITENT
                )
            );
        }
    }, [profiles, ucty]);

    useEffect(() => {
        // const redirect = !!profily;
        /* funkcionalita filtru api sa zavola po 900ms bez inputu alebo hned 
        ak input === '' */
        let delayDebounceFn: ReturnType<typeof setTimeout>;

        delayDebounceFn = setTimeout(
            () => {
                setSearching(true);
                profilyApi(searchValue).then(({ data }) => {
                    setLevel('profily', data);
                    setLevel('ucty', data.sezpristupu!);
                    setProfiles(data.sezpristupu!);
                    setSearching(false);
                    if (data.sezpristupu!.length === 0) {
                        firstRenderRef.current === true && navigateWorkaround(routePathEnum.NOVY_UCET);
                    }
                    firstRenderRef.current = false;
                });
            },
            searchValue ? 900 : 0
        );

        return () => clearTimeout(delayDebounceFn);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    return (
        <>
            <DashboardNotificationType profily={profiles} />
            <Row>
                <Col span={24}>
                    <Title
                        level={4}
                        text="SPRAVOVANE_EMITENT"
                        style={{
                            color: '#808585'
                        }}
                    />
                    <Input.Search
                        placeholder={getLanguageObject(language).MAIN_PAGE_FILTER_PLACEHOLDER}
                        allowClear={true}
                        enterButton={getLanguageObject(language).VYHLEDAT}
                        size="large"
                        onChange={ev => setSearchValue(ev.target.value)}
                        bordered={false}
                        loading={searching}
                        id="isinVyhledatSearch"
                        style={{
                            backgroundColor: 'white',
                            border: '1px solid #D4D6D6',
                            padding: '5px',
                            borderRadius: 6
                        }}
                        className="search-input"
                        prefix={<SearchOutlined style={{}} />}
                    />
                </Col>
            </Row>
            <Row gutter={16} justify="start">
                {emitentProfiles &&
                    emitentProfiles.map(
                        (e, i) =>
                            e.typ === EProfilyTyp.EMITENT && (
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    className="dashboard-card-col-card"
                                    key={e.iducet}
                                >
                                    <AnchorComponent
                                        onClick={() => {
                                            setLevel('dashboardLoading', true);
                                            setLevel('amlz', null);
                                            setLevel('lei', null);
                                            setLevel('menuProfile', null);
                                            setLevel('dashboardWrapperTopSelected', null);
                                            setLevel('aktivniFirma', e);

                                            nastavitUcetApi(e?.iducet).then(() =>
                                                emitentApi().then(data => {
                                                    if (Object.keys(data).length) {
                                                        setLevel('menuProfile', {
                                                            ...data,
                                                            typemitenta: data.typemitenta || EEmitentJe.NA
                                                        });
                                                        setLevel('dashboardLoading', false);
                                                        navigateWorkaround(
                                                            `/firma/${e.iducet}${routePathEnum.PREHLED_SPRAVA_EMITENTA}`
                                                        );
                                                    } else {
                                                        navigateWorkaround(
                                                            `/firma/${e.iducet}${routePathEnum.PREHLED_SPRAVA_EMITENTA}`
                                                        );
                                                        setLevel('dashboardLoading', false);
                                                    }
                                                })
                                            );
                                        }}
                                        className="hover-border"
                                    >
                                        <Card
                                            title={
                                                // title(
                                                <h4
                                                    style={{
                                                        marginTop: 8,
                                                        marginBottom: 4,
                                                        fontWeight: 700,
                                                        fontSize: 20
                                                    }}
                                                >
                                                    {e.spolecnost}
                                                </h4>
                                            }
                                            extra={extraButton(i)}
                                            className="dash-card"
                                            style={{
                                                height: '100%'
                                            }}
                                        >
                                            <p>
                                                <TranslateText>FORMULARE_IC</TranslateText> {e.ic}
                                            </p>
                                            {e.adresa && <p>{e.adresa}</p>}
                                            {e.seznotifikaci && e.seznotifikaci?.map(notifikaceMap)}
                                            {getAvailablePages(e)}
                                        </Card>
                                    </AnchorComponent>
                                </Col>
                            )
                    )}
            </Row>
        </>
    );
};

export default PrehledUcty;
